import React, { useState, useContext, useEffect } from 'react'
import { Card, CardHeader, CardBody, Nav, NavItem, TabPane, TabContent, NavLink, Row, Col, Input, Label, Form, FormFeedback } from 'reactstrap'
import Header from 'Layout/Header'
import { Container, IconButton } from '@mui/material'
import classnames from "classnames";
import { IMAGES_URL } from 'Utils/URLs';
import { getDisplayUrl } from 'Utils/mediaUrl';
import * as Yup from "yup"
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import { Button } from '@mui/material';
import AuthState from 'Hooks/Authinctication.state';
import PaymentComponent from 'Component/PaymentComponent/PaymentComponent';
import { UserContext } from 'Hooks/UserContext';
import { ToastContainer } from 'react-toastify';
import DriveWithUsState from 'Hooks/DriveWithUs.state';
import { Menu, MenuItem, Typography,Box } from '@mui/material';
import CarRepairIcon from "@mui/icons-material/CarRepair";
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';


const EditProfile = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(false);
    const [activeTab, setActiveTab] = useState("1")
    const [selectedImage, setSelectedImage] = useState({ file: null, preview: null });
    const { UpdateProfile, response, formBusy, GetUserProfile } = AuthState()
    const { GetDriveWithUs, loading, driveWithUsData } = DriveWithUsState()
    const location = useLocation()
    const { tabValue } = location.state || { tabValue: "1" };
    const accountData = sessionStorage.getItem("account")
    const searchParams = new URLSearchParams(location.search);
   
   
    const navigation = useNavigate()
    function isExpired(dateString) {
        const givenDate = new Date(dateString);
        const currentDate = new Date();

        return givenDate < currentDate;
    }
    useEffect(() => {
        GetDriveWithUs(user?.token)
    }, [])
    const { user, value, setValue } = useContext(UserContext)
    const onFileChange = (e) => {
        setSelectedImage({
            file: e.target.files[0],
            preview: URL.createObjectURL(e.target.files[0])
        });
    }

    
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const tabChange = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const profileValidation = useFormik({
        enableReinitialize: true,

        initialValues: {

            started_from: user?.created_at ? new Date(user.created_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            first_name: user?.first_name || "",
            last_name: user?.last_name || "",
            company: user?.company || "",
            email: user?.email || "",
            phone: user?.phone || "",
            address: user?.address || "",
            apt: user?.apt || "",
            city: user?.city || "",
            state: user?.state || "",
            zip_code: user?.zip_code || "",


        },
        validationSchema: Yup.object({
            first_name: Yup.string().required("First name is required"),
            last_name: Yup.string().required("Last name is required"),
            company: Yup.string(),
            email: Yup.string().required('Email is required').email('Enter valid email'),
            phone: Yup.string().required("Phone is required"),
            address: Yup.string(),
            apt: Yup.string(),
            street_name: Yup.string(),
            city: Yup.string(),
            state: Yup.string(),
            zip_code: Yup.string(),

        }),
        onSubmit: (values) => {
            const formData = new FormData()
            formData.append("created_at", values.started_from || new Date().toISOString().split('T')[0])
            formData.append("first_name", values.first_name)
            formData.append("last_name", values.last_name)
            formData.append("company", values.company || "")
            formData.append("address", values.address)
            formData.append("apt", values.apt)
            formData.append("city", values.city)
            formData.append("state", values.state)
            formData.append("zip_code", values.zip_code)
            formData.append("phone", values.phone)
            formData.append("email", values.email)
            formData.append("profile_pic", selectedImage.file)

            console.log(values)

            UpdateProfile(formData);

        }
    });
   

    const mobileTabs = [
        {
            value: "one",
            label: "Profile",
            icon: <i className="las la-user" />,
            condition: true,
        },
        {
            value: "three",
            label: "Drive With Us",
            icon: <i className="las la-car" />,
            condition:
                user?.form_name === "drive_with_us" &&
                driveWithUsData.some(
                    (item) => isExpired(item.file_expiry) || item.file_status === 2
                ),
        },
        {
            value: "three",
            label: "Partner With Us",
            icon: <i className="mdi mdi-handshake-outline" />,
            condition:
                user?.form_name === "partner_with_us"
        },
        {
            value: "three",
            label: "Get Free Ride",
            icon: <i className="mdi mdi-taxi" />,
            condition:
                user?.form_name === "free_ride"
        },
        {
            value: "two",
            label: "Account",
            icon: <i className="ri-bank-line -mt-5" />,
            condition: user?.status === "1",
        },
        {
            value: "four",
            label: "Update Car Information",
            icon: <CarRepairIcon />,
            condition: user?.form_name === "drive_with_us" && driveWithUsData.length > 0,
        },
    ]

    return (
        <Box className='edit-profile mb-3 p-2' sx={{background:{xs:"linear-gradient(180deg,rgba(151, 193, 31, 1) 26%, rgba(233, 255, 166, 1) 67%, rgba(255, 255, 255, 1) 94%)",md:"#FFF"}}} >
            <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                PaperProps={{
                    sx: {
                        mt: 6.5,
                        backgroundColor: '#021B38', // deep blue
                        color: '#96c11e',
                        borderRadius: 2,
                        boxShadow: 3,
                        minWidth: 200,
                        '& .MuiMenuItem-root': {
                            gap: 1,
                            paddingY: 1,
                            paddingX: 2,
                            '&:hover': {
                                backgroundColor: '#021B48',
                            },
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#96c11e',
                        },
                    },
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {mobileTabs.map((tab) => (
                    tab.condition && (
                        <MenuItem key={tab.value} onClick={() => { setValue(tab.value); handleCloseNavMenu() }}>
                            {tab.icon}
                            <Typography>{tab.label}</Typography>
                        </MenuItem>
                    )
                ))}


            </Menu>
            <ToastContainer />
            <div className="cover-image  m-md-5 pb-5  " style={{ borderRadius: 10 }} >
                <Header setValue={setValue} />
                <Container sx={{ pt: { xs: 1, md: 4 } }} >

                </Container>
            </div>
            <Container>

                <Row>
                    <Col xxl={3} md={6} >
                        <Card className=" mt-n5">
                            <IconButton onClick={() => {navigation("/driver_forms/profile");setValue(1)}} sx={{ backgroundColor: "#92c323", m: 2, px: 3, color: "#FFF",width:"fit-content", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </IconButton>
                            <CardBody className="p-4">
                                <div className="text-center">
                                    <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                                        <img src={user?.profile_pic? getDisplayUrl(user.profile_pic, IMAGES_URL) : selectedImage.preview ? selectedImage.preview : "/driver_forms/assets/images/user-dummy-img.jpg"}
                                            className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                            alt="user-profile" />
                                        <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                            <Input onChange={onFileChange} id="profile-img-file-input" type="file"
                                                className="profile-img-file-input" />
                                            <Label htmlFor="profile-img-file-input"
                                                className="profile-photo-edit avatar-xs">
                                                <span className="avatar-title rounded-circle bg-light text-body">
                                                    <i className="ri-camera-fill"></i>
                                                </span>
                                            </Label>
                                        </div>
                                    </div>
                                    <h5 className="fs-17 mb-1 edit-title ">{user?.first_name} {user?.last_name} </h5>
                                    <p className="text-muted mb-2 edit-desc " >{user?.email}</p>
                                </div>
                            </CardBody>
                        </Card>


                    </Col>
                    <Col xxl={9} md={6} >
                        <Card className="mt-n5" >
                            <CardHeader style={{ backgroundColor: "#FFF" }}  >
                                <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                    role="tablist">
                                        
                                    <NavItem>
                                        <NavLink
                                            href='#'
                                            className={classnames({ active: activeTab === "0" })}
                                            style={{color:"#000"}}
                                            onClick={() => {
                                                tabChange("1");
                                            }}>
                                            <i className="fas fa-home"></i>
                                            Personal Details
                                        </NavLink>
                                    </NavItem>
                                   
                                    


                                </Nav>
                            </CardHeader>
                            <CardBody>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                profileValidation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row >

                                                <Col xxl={4} lg={6} className="mb-3">
                                                    <Label className="form-label" htmlFor="started_from">
                                                        Started from
                                                    </Label>
                                                    <Input
                                                        type="date"
                                                        className="form-control p-2 "
                                                        id="started_from"
                                                        name="started_from"
                                                        value={profileValidation.values.started_from || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                    />
                                                </Col>
                                                <Col xxl={4} lg={6} className="mb-3 ">
                                                    <Label className="form-label" htmlFor="first_name">
                                                        First name
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="first_name"
                                                        placeholder="Enter first name"
                                                        name="first_name"
                                                        value={profileValidation.values.first_name || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.first_name && profileValidation.touched.first_name ? true : false}
                                                    />
                                                    {profileValidation.errors.first_name && profileValidation.touched.first_name ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.first_name}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col xxl={4} lg={6} className="mb-3">
                                                    <Label className="form-label" htmlFor="last_name">
                                                        Last name
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="last_name"
                                                        placeholder="Enter first name"
                                                        name="last_name"
                                                        value={profileValidation.values.last_name || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.last_name && profileValidation.touched.last_name ? true : false}
                                                    />
                                                    {profileValidation.errors.last_name && profileValidation.touched.last_name ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.last_name}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col xxl={4} lg={6} className="mb-3">
                                                    <Label className="form-label" htmlFor="company">
                                                        Company
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="company"
                                                        placeholder="Enter company"
                                                        name="company"
                                                        value={profileValidation.values.company || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.company && profileValidation.touched.company ? true : false}
                                                    />
                                                    {profileValidation.errors.company && profileValidation.touched.company ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.company}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="email">
                                                        Email
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        id="email"
                                                        placeholder="Enter email"
                                                        className="form-control p-2 "
                                                        name="email"
                                                        value={profileValidation.values.email || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.email && profileValidation.touched.email ? true : false}
                                                    />
                                                    {profileValidation.errors.email && profileValidation.touched.email ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </Col>

                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <div className=" mb-xl-0">
                                                        <label htmlFor="cleave-phone" className="form-label">Phone</label>
                                                        <PhoneInput
                                                            disableCountryCode
                                                            onlyCountries={["us"]}
                                                            country={"us"}
                                                            placeholder='Enter your 10 digit phone number'
                                                            id="phone" name="phone"
                                                            onChange={profileValidation.handleChange}
                                                            onBlur={profileValidation.handleBlur}
                                                            className={`form-control p-0  ${profileValidation.errors.phone ? "is-invalid" : ""}`}
                                                        />
                                                        {/* <Cleave
                                                            placeholder="xxx xxx-xxxx"
                                                            options={{
                                                                phone: true,
                                                                phoneRegionCode: "US"
                                                            }}
                                                            value={profileValidation.values.phone || ""}
                                                            onChange={profileValidation.handleChange}
                                                            onBlur={profileValidation.handleBlur}
                                                            className={`form-control p-2  ${profileValidation.errors.phone ? "is-invalid" : ""}`}
                                                            name="phone"
                                                            id="cleave-phone"
                                                            type="text"
                                                        /> */}
                                                        {profileValidation.touched.phone && profileValidation.errors.phone ? (
                                                            <FormFeedback type="invalid">{profileValidation.errors.phone}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="address">
                                                        Address
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="address"
                                                        placeholder="Enter address"
                                                        name="address"
                                                        value={profileValidation.values.address || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.address && profileValidation.touched.address ? true : false}
                                                    />
                                                    {profileValidation.errors.address && profileValidation.touched.address ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.address}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="apt">
                                                        Apt, Suite, Unit, Bulding, Floor, etc
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="apt"
                                                        placeholder="Enter apt, suite, unit, bulding, floor, etc"
                                                        name="apt"
                                                        value={profileValidation.values.apt || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.apt && profileValidation.touched.apt ? true : false}
                                                    />
                                                    {profileValidation.errors.apt && profileValidation.touched.apt ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.apt}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="city">
                                                        City
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="city"
                                                        placeholder="Enter city"
                                                        name="city"
                                                        value={profileValidation.values.city || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.city && profileValidation.touched.city ? true : false}
                                                    />
                                                    {profileValidation.errors.city && profileValidation.touched.city ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.city}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="state">
                                                        State
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="state"
                                                        placeholder="Enter state"
                                                        name="state"
                                                        value={profileValidation.values.state || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.state && profileValidation.touched.state ? true : false}
                                                    />
                                                    {profileValidation.errors.state && profileValidation.touched.state ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.state}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={6} xxl={4} className="mb-3">
                                                    <Label className="form-label" htmlFor="zip_code">
                                                        Zip code
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control p-2 "
                                                        id="zip_code"
                                                        placeholder="Enter zip code"
                                                        name="zip_code"
                                                        value={profileValidation.values.zip_code || ""}
                                                        onBlur={profileValidation.handleBlur}
                                                        onChange={profileValidation.handleChange}
                                                        invalid={profileValidation.errors.zip_code && profileValidation.touched.zip_code ? true : false}
                                                    />
                                                    {profileValidation.errors.zip_code && profileValidation.touched.zip_code ? (
                                                        <FormFeedback type="invalid">{profileValidation.errors.zip_code}</FormFeedback>
                                                    ) : null}
                                                </Col>
                                                <Col lg={12}>
                                                    <div className='' >
                                                        <Button sx={{ backgroundColor: "#021b38", width: "40%", '&:hover': { backgroundColor: "#76a521" } }} size="large" variant="contained" color="secondary" type="submit" >
                                                            {formBusy ? "Please wait..." : "Update"}
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </Box>
    )
}

export default EditProfile